import React, { useEffect, useState } from 'react'
import { CFormLabel as CLabel, CFormInput as CInput, CFormSelect as CSelect, CRow, CCol, CContainer, CFormSelect } from '@coreui/react'

import CustomDatePickingFormatForAddNewPatient from '../../components/shared/CustomDatePickingFormatForAddNewPatient.jsx'

const AddPatientForm = ({ formData, setFormData, isEditable = true, errors }) => {
  const [patientStatus, setPatientStatus] = useState([
    { value: 1, label: 'New Patient' },
    { value: 2, label: 'Follow Up' },
    { value: 3, label: 'Re-Admit' },
  ])

  const [calAge, setCalAge] = useState(0)
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }
  function calculateAge(dob) {
    const today = new Date()
    const birthDate = new Date(dob)
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDifference = today.getMonth() - birthDate.getMonth()
    const dayDifference = today.getDate() - birthDate.getDate()
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--
    }
    let data = {
      target: { name: 'Age', value: age },
    }
    handleChange(data)
    return age
  }

  console.log(formData.DOB)

  useEffect(() => {
    if (formData.DOB) {
      calculateAge(formData.DOB)
    }
  }, [formData.DOB])

  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
  ]

  const selectedOption = selectStatusOption.find((option) => option.value === formData.Status)

  return (
    <CContainer className="add-patient-form">
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel htmlFor="firstName">First Name</CLabel>
          <CInput type="text" id="firstName" name="FirstName" value={formData.FirstName} onChange={handleChange} required disabled={!isEditable} placeholder="First Name" style={{ fontSize: '14px' }} />
          {errors.FirstName && <small className="patient-theme-error">{errors.FirstName}</small>}
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="middleName">Middle Name</CLabel>
          <CInput type="text" id="middleName" name="MiddleName" value={formData.MiddleName} onChange={handleChange} disabled={!isEditable} placeholder="Middle Name" style={{ fontSize: '14px' }} />
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel htmlFor="lastName">Last Name</CLabel>
          <CInput type="text" id="lastName" name="LastName" value={formData.LastName} onChange={handleChange} required disabled={!isEditable} placeholder="Last Name" style={{ fontSize: '14px' }} />
          {errors.LastName && <small className="patient-theme-error">{errors.LastName}</small>}
        </CCol>
        <CCol md="6" className="flex-column d-flex">
          <CLabel htmlFor="dob">Date of Birth</CLabel>
          {/* <CInput
            type="date"
            id="dob"
            name="DOB"
            value={formData.DOB}
            onChange={handleChange}
            required
            disabled={!isEditable}
          /> */}
          <CustomDatePickingFormatForAddNewPatient
            value={formData.DOB}
            maxDate={new Date()}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                DOB: e,
              }))
            }}
          />
          {errors.DOB && <small className="patient-theme-error">{errors.DOB}</small>}
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel htmlFor="gender">Gender</CLabel>
          <CSelect id="gender" name="Gender" value={formData.Gender} onChange={handleChange} required disabled={!isEditable}>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </CSelect>
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="age">Age</CLabel>
          <CInput type="number" id="age" name="Age" value={formData.Age} onChange={handleChange} required disabled={!isEditable} placeholder="Age" style={{ fontSize: '14px' }} />
        </CCol>
      </CRow>
      {/* <CRow>
        <CCol md="6">
          <div className="my-3">
            <CLabel>Patient Status</CLabel>
            <Select
              placeholder="Select"
              name="Status"
              options={patientStatus}
            // value={formData.Status}
            // onChange={(e) => setFormData((prevData) => ({
            //   ...prevData,
            //   Status: e,
            // }))}
            />
          </div>
        </CCol>

      </CRow> */}
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="phoneNumber">Phone Number</CLabel>
          <CInput
            type="text"
            id="phoneNumber"
            name="PhoneNumber"
            value={formData.PhoneNumber}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
        <CCol md="6">
          <CLabel htmlFor="emergencyName">Emergency Contact Name</CLabel>
          <CInput type="text" id="emergencyName" name="EmergencyName" value={formData.EmergencyName} onChange={handleChange} required disabled={!isEditable} placeholder="Emergency Contact Name" style={{ fontSize: '14px' }} />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="emergencyPhone">Emergency Contact Phone</CLabel>
          <CInput type="text" id="emergencyPhone" name="EmergencyPhone" value={formData.EmergencyPhone} onChange={handleChange} required disabled={!isEditable} placeholder="Emergency Contact Phone" style={{ fontSize: '14px' }} />
        </CCol>
      </CRow>
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="emergencyPhone">Emergency Contact Phone</CLabel>
          <CInput
            type="text"
            id="emergencyPhone"
            name="EmergencyPhone"
            value={formData.EmergencyPhone}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
        {/* <CCol md="6">
          <CLabel htmlFor="emergencyPhone">Status</CLabel>
          <Select
            name='Status'
            onChange={(e)=>{
              setFormData((prevData) => ({
               ...prevData,
                Status: e.value,
              }))
            }}
            value={selectedOption}
            options={selectStatusOption}
          />
        </CCol> */}
        {/* <CCol md="6">
          <CLabel htmlFor="address">Address</CLabel>
          <CInput
            type="text"
            id="address"
            name="Address"
            value={formData.Address}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="state">State</CLabel>
          <CInput
            type="text"
            id="state"
            name="State"
            value={formData.State}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="city">City</CLabel>
          <CInput
            type="text"
            id="city"
            name="City"
            value={formData.City}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="zipCode">Zip Code</CLabel>
          <CInput
            type="text"
            id="zipCode"
            name="ZipCode"
            value={formData.ZipCode}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="country">Country</CLabel>
          <CInput
            type="text"
            id="country"
            name="Country"
            value={formData.Country}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
    </CContainer>
  )
}

export default AddPatientForm
